// Folder icon helpers — gives existing folders (created before auto-icon
// assignment shipped) a deterministic-but-varied fallback icon based on
// folder id. So even legacy folders look distinct instead of all rendering
// as the same FolderOpen.
//
// New folders get a default-icon name written at create time
// (see useAppFolders.createFolder). Old folders fall back through here.

// Same rotation pool as DEFAULT_FOLDER_ICONS in useAppFolders.ts.
// Keep in sync if you reorder/extend either list.
export const FOLDER_ICON_POOL = [
  "Folder",
  "Briefcase",
  "Star",
  "Bookmark",
  "Tag",
  "Archive",
  "Package",
  "Box",
  "Gift",
  "Heart",
  "Flag",
  "Layers",
  "Grid3X3",
  "Compass",
  "Sparkles",
  "Zap",
  "Rocket",
  "Target",
  "Trophy",
  "Crown",
];

/**
 * Derive a deterministic icon name from a folder id. Used as a fallback
 * for folders that have a null `icon` column (created before auto-assign).
 * Same id always returns the same icon — so the UI doesn't shuffle on reload.
 */
export function fallbackFolderIcon(folderId: string): string {
  let hash = 0;
  for (let i = 0; i < folderId.length; i++) {
    hash = (hash * 31 + folderId.charCodeAt(i)) | 0;
  }
  const idx = Math.abs(hash) % FOLDER_ICON_POOL.length;
  return FOLDER_ICON_POOL[idx];
}
